import _ from 'lodash';
import Vue from 'vue';

const mapKey = function(key) {
	return key
			.replace(/\.(\d)\./i, "[$1].")
			.replace(/\./i, '_');
}

const state = {
	errors: {}
}


const mutations = {

	put: function(state, payload) 
	{
		let valid_key = mapKey(payload.key);
		let errors = Object.assign({}, state.errors);
		_.set(errors, valid_key, payload.value);
		state.errors = Object.assign({}, errors);
	},

	unset: function(state, key) 
	{
		let valid_key = mapKey(key);
		let errors = Object.assign({}, state.errors);
		_.unset(errors, valid_key);
		state.errors = Object.assign({}, errors);
	},

	clear: function(state) 
	{
		state.errors = {};
	},
}


const actions = {


	fromResponse: function(context, payload)
	{
		if (_.isArray(payload.errors)) {
			_.forEach(payload.errors, function(error) {
				context.dispatch('processError', error);
			});
		} else if (_.isObject(payload.errors)) {
			context.dispatch('processError', payload.errors);
		}
	},

	processError: function(context, error)
	{
		let payload = {
			key:   _.get(error, "meta.input", "error"),
			value: _.get(error, "title")
		}
		context.commit('put', payload);
	},

	put: function(context, payload)
	{
		context.commit('put', payload);
	},

	unset: function(context, id)
	{
		if (_.has(context.state.errors, id, null)) context.commit('unset', id);
	},

	clear: function(context)
	{
		context.commit('clear');
	},

}

const getters = {

	get: (state, getters, rootState, rootGetters) => id => {
		return _.get(state.errors, id, null);
	},

	has: (state, getters, rootState, rootGetters) => id => {
		return _.has(state.errors, id);
	},
}


export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}